module.exports = __webpack_public_path__ + "static/media/logo_copy.447b4f29.png";